class BoundaryService {
    configurations = [];

    constructor() {
        this.threshold = 0.000001;
    }

    setConfigurations(configurations) {
        this.configurations = configurations;
    }

    getLocation(point) {
         const result = {
            isInside: true,
            boundary: undefined,
            point: point
        };
        for (let configuration of this.configurations) {
            if (configuration.boundaryConfig.isInside(point)) {
                result.isInside = (configuration.mode === "Allow");
                result.boundary = configuration.boundaryConfig.getBoundingBox();
            }
        }
        return result;
    }

    getNextPoint(fromLocation, toLocation) {
        const direction = new THREE.Vector3();
        direction.subVectors(fromLocation.point, toLocation.point).normalize();
        const intersectPoint = this.getBoundaryIntersectionPoint(toLocation.point, direction, toLocation.boundary);
        intersectPoint.add(direction.multiplyScalar(this.threshold));
        return intersectPoint;
    }

    getBoundaryIntersectionPoint(origin, direction, bBox) {
        raycast.camera = iq3Camera.getCamera();
        raycast.ray.origin.copy(origin);
        raycast.ray.direction.copy(direction);
        return raycast.ray.intersectBox(bBox, direction);
    }


    isAllowed(from, to) {
        const fromLocation = this.getLocation(from);
        const toLocation = this.getLocation(to);

        if (!toLocation.isInside || !fromLocation.isInside) {
            return false;
        }

        if (toLocation.isInside && fromLocation.isInside) {
            return true;
        }

        if (toLocation.boundary === fromLocation.boundary) {
            return true;
        }

        const nextTo = this.getNextPoint(fromLocation, toLocation);

        return this.isAllowed(from, nextTo);
    }

    getValidPosition(from, to) {
        const fromLocation = this.getLocation(from);
        const toLocation = this.getLocation(to);

        if (toLocation.isInside && fromLocation.isInside) {
            return to.clone();
        }

        if (!toLocation.isInside || !fromLocation.isInside) {
            return from.clone();
        }

        return to.clone();
    }
}

export default new BoundaryService();
